<template>
  <div class="choice">
    <div v-html="'<b>' + (id+1) + '</b>. ' + problem.description" class="description"></div>
    <div v-for="(option, i) in options"
         @click="$emit('select', id, option[0])">
      <div :class="{
              'is-done': showAnswer,
              'is-selected': select === option[0],
              'is-answer': parseInt(problem.answer) === option[0],
              'is-wrong': parseInt(problem.answer) !== option[0] }"
           class="option">
        <b class="option-index">{{ String.fromCharCode(65 + i) }}</b>
        <div v-html="option[1]" class="content"></div>

        <div class="is-flex flex-pull-right">
          <img v-for="user in getOptionUsers(option)" class="head-image" :src="user" alt="">
        </div>
      </div>
    </div>
    <editor-content v-if="showAnswer"
                    class="answer focus-wave"
                    :content="problem.explanation_content">
    </editor-content>
  </div>
</template>
<style lang="stylus" scoped>
.answer {
  padding 2rem 1rem 1rem
  margin-bottom 5px
  background $linkLight
  color $linkFront
  border-radius 10px
  position relative
  overflow hidden

  &:before {
    content '解析'
    font-size 12px
    background $link
    padding 2px 10px
    display inline-block
    color white
    border-radius 5px 5px 10px 5px
    position absolute
    left 0
    top 0
  }
}
</style>
<script>
import EditorContent from '@/common/tinymce/EditorContent'

export default {
  components: { EditorContent },
  props: {
    problem: {
      required: true
    },
    select: {},
    id: {},
    showAnswer: { default: false },
    teammates: {}
  },
  data () {
    return {
      selectedOption: ''
    }
  },
  computed: {
    options () {
      if (this.problem.content) {
        return JSON.parse(this.problem.content)
      }
      return []
    }
  },
  methods: {
    selectAnswer (option) {
      this.$emit('select', option)
    },
    getOptionUsers (option) {
      if (!this.showAnswer) return []
      return this.teammates.filter(user => {
        return user.answer[this.id] === option[0]
      }).map(user => user.head_image).reverse()
    }
  }
}
</script>
